import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import axiosInstance from 'src/utils/axios';

interface UseDeleteCartMutationOptions {
  onSuccess?: (data: any, request: number[]) => void;
  onError?: (error: any) => void;
}

const useDeleteCartMutation = ({ onSuccess, onError }: UseDeleteCartMutationOptions = {}) => {
  const mutation = useMutation({
    mutationFn: async (request: number[]) => {
      const response = await axiosInstance.post(api.deleteCart, request);
      return response.data;
    },
    onSuccess: (data, request) => {
      onSuccess?.(data, request);
    },
    onError: (error) => {
      onError?.(error);
    },
  });

  return mutation;
};

export default useDeleteCartMutation;
